// import { Modal, Checkbox, Upload, Button, Form, Row, Col , Image } from 'antd';
// import { UploadOutlined } from '@ant-design/icons';
// import { useEffect, useState } from 'react';
// import type { FPs } from '../../../../types/CreateProductType';
// import { apiRequest } from '../../../../service/apiRequest';


// const FpParentChildModal = ({
//   visible,
//   onCancel,
//   onSubmit,
//   fp_parent,
//   fpData,
// }: {
//   visible: boolean;
//   onCancel: () => void;
//   onSubmit: (data: { selectedFpIds: number[]; image: File | null }) => void;
//   fp_parent: string | null;
//   fpData?: FPs[];
// }) => {
//   const [selectedFpIds, setSelectedFpIds] = useState<number[]>([]);
//   const [uploadFile, setUploadFile] = useState<File | null>(null);




//   const handleOk = () => {
//     onSubmit({ selectedFpIds, image: uploadFile });
//     onCancel();
//   };

//   return (
//     <Modal visible={visible}
//       title="Select Fabric Child Pattern"
//       onCancel={onCancel}
//       onOk={handleOk}
//       width="95%"
//       destroyOnClose
//       centered
//       maskClosable={false}
//     >
//       {fpData?.map(child => (
//         <>
//           <div key={child.fp_id} style={{ display: 'flex', alignItems: 'center', marginBottom: 10 }}>
//             <Row gutter={[16, 16]} style={{ margin: "15px" }}>
//               <Col xs={24} sm={12} md={12}>
//                 <Checkbox
//                   checked={selectedFpIds.includes(child.fp_id)}
//                   onChange={e => {
//                     const checked = e.target.checked;
//                     setSelectedFpIds(prev =>
//                       checked ? [...prev, child.fp_id] : prev.filter(id => id !== child.fp_id)
//                     );
//                   }}
//                 >
//                   {child.fp_pattern}
//                 </Checkbox>
//               </Col>
//               <Col xs={24} sm={12} md={12}>
//                 {child.fp_image && (
//                   <Image
//                     src={child.fp_image}
//                     alt={child.fp_pattern}
//                     width={200}
//                     style={{  marginLeft: 10, objectFit: 'cover' }}
//                   />
//                 )}
//               </Col>
//             </Row>
//           </div >
//         </>
//       ))
//       }
//     </Modal >
//   );
// };

// export default FpParentChildModal;

import React, { useEffect } from 'react';
import { Modal, Checkbox, Upload, Button, Form, Image, Table, Row, Col } from 'antd';
import { UploadOutlined } from '@ant-design/icons';
import { useState } from 'react';
import type { FPs } from '../../../../types/CreateProductType';
import Width from '../../masters/widths';

const FpParentChildModal = ({
  visible,
  onCancel,
  onSubmit,
  fp_parent,
  fpData,
  initialSelectedIds = [],
}: {
  visible: boolean;
  onCancel: () => void;
  onSubmit: (data: { selectedFpIds: number[]; image: File | null }) => void;
  fp_parent: string | null;
  fpData?: FPs[];
  initialSelectedIds?: number[]; // <-- ADD THIS
}) => {
  const [selectedFpIds, setSelectedFpIds] = useState<number[]>([]);
  const [uploadFile, setUploadFile] = useState<File | null>(null);

  const handleOk = () => {
    onSubmit({ selectedFpIds, image: uploadFile });
    onCancel();
  };

  useEffect(() => {
    if (visible && initialSelectedIds.length > 0) {
      setSelectedFpIds(initialSelectedIds);
    }
  }, [visible, initialSelectedIds]);

  return (
    <Modal
      visible={visible}
      title="Select Fabric Child Pattern"
      onCancel={onCancel}
      onOk={handleOk}
      width="95%"
      destroyOnClose
      centered
      maskClosable={false}
      bodyStyle={{ maxHeight: '85vh', overflowY: 'auto',  overflowX: 'hidden',  }}
    >

      <Row gutter={[16, 16]}>
        {fpData?.map((fp) => (
          <Col key={fp.fp_id} xs={24} sm={12} md={8}>
            <div
              style={{
                display: 'flex',
                justifyContent: 'space-between', // ✅ horizontal layout
                alignItems: 'center',
                gap: 12,
                padding: 12,
                borderRadius: 8,
                background: '#fafafa',
              }}
            >
              {/* ✅ Left: Checkbox with pattern name */}
              <Checkbox
                checked={selectedFpIds.includes(fp.fp_id)}
                onChange={(e) => {
                  const checked = e.target.checked;
                  setSelectedFpIds((prev) =>
                    checked
                      ? [...prev, fp.fp_id]
                      : prev.filter((id) => id !== fp.fp_id)
                  );
                }}
              >
                {fp.fp_pattern}
              </Checkbox>

              {/* ✅ Right: Image */}
              {fp.fp_image ? (
                <Image
                  src={fp.fp_image}
                  alt={fp.fp_pattern}
                  width={100}
                  height={100}
                  style={{ objectFit: 'cover', borderRadius: 4 }}
                  preview={true}
                />
              ) : (
                <div
                  style={{
                    width: 100,
                    height: 80,
                    background: '#eee',
                    display: 'flex',
                    justifyContent: 'center',
                    alignItems: 'center',
                    borderRadius: 4,
                  }}
                >
                  No Image
                </div>
              )}
            </div>
          </Col>
        ))}
      </Row>
    </Modal>
  );
};

export default FpParentChildModal;
